<div class="sidebar-wrapper">

  <a class="sidebar-brand" (click)="redirecToIndex()" role="button" tabindex="0">
    <img
      [src]="'/assets/images/logo-app.png'"
      alt="CAEGP"
      class="sidebar-brand__icon"
    />
  </a>

  <ul
    [nzInlineCollapsed]="false"
    class="nav"
    nz-menu
    nzMode="inline"
    nzTheme="light"
  >
    <ng-container *ngFor="let menuItem of menuItems">
      <li
        *ngIf="menuItem.children.length == 0"
        [nzSelected]="activatedLinkChecker(menuItem.path)"
        class="icon-sidebar"
        nz-menu-item
        routerLink="{{ menuItem.path }}"
        routerLinkActive="active"
      >
        <span nz-icon nzType="{{ menuItem.icon }}"></span>
        <span>{{ menuItem.name }}</span>
      </li>
      <li
        *ngIf="menuItem.children.length > 0"
        nz-submenu
        nzIcon="{{ menuItem.icon }}"
        nzTitle="{{ menuItem.name }}"
      >
        <ul *ngIf="menuItem.children.length > 0">
          <li
            *ngFor="let childItem of menuItem.children"
            [nzSelected]="activatedLinkChecker(childItem.path)"
            class="icon-sidebar"
            nz-menu-item
            routerLink="{{ childItem.path }}"
            routerLinkActive="{{ activatedLinkChecker(childItem.path) }}"
          >
            {{ childItem.name }}
          </li>
        </ul>
      </li>
    </ng-container>
  </ul>

  <div class="sidebar-foot">
    <div class="sidebar-help">
      <div class="sidebar-help__title">Besoin d'aide&nbsp;?</div>
      <div class="sidebar-help__sub">
        Consultez la documentation ou contactez le support.
      </div>
    </div>
  </div>
</div>
